"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillingAddressSchema = void 0;
const joi_1 = __importDefault(require("joi"));
exports.BillingAddressSchema = joi_1.default.object({
    customerSalesforceId: joi_1.default.string().required(),
    accountNumber: joi_1.default.string(),
    city: joi_1.default.string(),
    companyName: joi_1.default.string().allow(null),
    country: joi_1.default.string().required(),
    countryCode: joi_1.default.string().required(),
    currency: joi_1.default.string(),
    invoiceRecipient: joi_1.default.string().allow(null),
    invoiceRecipientEmail: joi_1.default.string(),
    name: joi_1.default.string().required(),
    postalCode: joi_1.default.string().required(),
    state: joi_1.default.string(),
    stateCode: joi_1.default.string(),
    street: joi_1.default.string().required(),
    uuid: joi_1.default.string().required(),
    vatNumber: joi_1.default.string().allow(null),
    vatValidated: joi_1.default.boolean(),
    createdAt: joi_1.default.date().required(),
    updatedAt: joi_1.default.date().required(),
    organizationUuid: joi_1.default.string().uuid().required()
}).meta({ className: 'BillingAddress' });
//# sourceMappingURL=BillingAddressSchema.js.map